import { Component } from '@angular/core';

/**
 * Uses the primary horizontal brand lockup (assets/img/certacure-logo.png) - the full-colour
 * pinwheel mark followed by the "certacure" wordmark, taken straight from the supplied master
 * artwork. The asset is trimmed to the artwork's own bounds (no baked-in padding) and stored at
 * 923x264 - 6x the rendered topbar height - so the browser downscales it once, from plenty of
 * source pixels, and it stays sharp well past 3x pixel density.
 *
 * It is deliberately not taken from the `Icons` registry: 'logoIcon'/'logoIconAnniversary' there
 * are white knockout variants meant for the old dark topbar and are invisible against the light
 * topbar, and both carry a tagline the header has no room for.
 */
@Component({
    selector: 'app-shell-logo',
    templateUrl: './app-shell-logo.component.html',
    styleUrls: ['./app-shell-logo.component.scss'],
})
export class AppShellLogoComponent {
    readonly logoSrc = 'assets/img/certacure-logo.png';
}
